import type { Cluster } from './types'

export interface DayGroup {
  day: string
  clusters: Cluster[]
}

const dayFormat = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'short' })

const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()

// Web's copy of mobile/src/eventDays.ts, held to the same behaviour by
// mobile/src/ruleParity.test.ts.
//
// dayGroups puts incidents under the local day each one last changed, newest
// day first, keeping their order within a day. Days are compared by calendar date rather than by 24-hour steps,
// so a daylight change cannot move an incident across.
export function dayGroups(clusters: Cluster[], now: Date = new Date()): DayGroup[] {
  const today = startOfDay(now)
  const yesterday = startOfDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1))
  // By day rather than by run: a refinement updates an incident where it
  // sits, so one running past midnight sits among yesterday's, and grouping
  // runs showed a day twice (#287). The list keeps its order within a day, so
  // a refined incident does not jump under the dispatcher's pointer.
  const byDay = new Map<number, DayGroup>()
  for (const c of clusters) {
    const when = new Date(c.end_time * 1000)
    const start = startOfDay(when)
    const group = byDay.get(start)
    if (group) group.clusters.push(c)
    else byDay.set(start, { day: start === today ? 'Today' : start === yesterday ? 'Yesterday' : dayFormat.format(when), clusters: [c] })
  }
  return [...byDay.entries()].sort(([a], [b]) => b - a).map(([, g]) => g)
}
